export const SNOWPACK_PUBLIC_API_V3_URL = import.meta.env.VITE_PUBLIC_API_V3_URL ?? ''
